// ** Router imports
import { lazy, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
// ** Router imports
import { useRoutes, Navigate } from 'react-router-dom'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'

// ** Hooks Imports
import { useLayout } from '@hooks/useLayout'

// ** Utils
import { getUserData, getHomeRouteForLoggedInUser } from '../utility/Utils'

// ** GetRoutes
import { getRoutes } from './routes'
import { useDispatch } from 'react-redux'
import { useRef } from 'react'


// ** Components
const Error = lazy(() => import('../views/pages/misc/Error'))
const Login = lazy(() => import('../views/pages/authentication/LoginBasic'))
const NotAuthorized = lazy(() => import('../views/pages/misc/NotAuthorized'))

const Router = () => {
  // ** Hooks
  const { layout } = useLayout()
  const user = getUserData()
  const dispatch = useDispatch()
  const [notification, setNotification] = useState({ title: '', body: '' })
  const notify = () =>
    toast(<ToastDisplay />, {
      duration: 6000,
      position: 'top-right',
      style: {},
      className: '',
      iconTheme: {
        primary: '#000',
        secondary: '#fff'
      }
    })
  function ToastDisplay() {
    return (
      <div>
        <p className='mb-0'>
          <b>{notification?.title}</b>
        </p>
        <p className='mb-0'>{notification?.body}</p>
      </div>
    )
  }

  let src = require('../assets/sound.mp3').default
  const [playing, setPlaying] = useState(false)
  const audioRef = useRef(new Audio(src))

  const allRoutes = getRoutes(layout)
  const getHomeRoute = () => {
    const user = getUserData()
    if (user) {
      return getHomeRouteForLoggedInUser(user.role)
    } else {
      return '/login'
    }
  }

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <BlankLayout />,
      children: [{ path: '/login', element: <Login /> }]
    },
    {
      path: '/auth/not-auth',
      element: <BlankLayout />,
      children: [{ path: '/auth/not-auth', element: <NotAuthorized /> }]
    },
    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ])

  return routes
}

export default Router
